import FamilyCreateNewRequest from "./ResponsiveEvent.jsx/FamilyCreateNewRequest"
import { FormProvider } from './FormContext'

function FamilyCreate() {

  return (
    <FormProvider>
      <FamilyCreateNewRequest  />
    </FormProvider>
  )

}

export default FamilyCreate;